import * as React from 'react'
import Stack from '@mui/material/Stack'
import { Divider, HelperText } from '../atoms'
interface Props {
  counter: number
  maxLength: number
  message?: string
}
export function RuleFieldHelperText(props: Props) {
  const { counter, maxLength, message } = props
  return (
    <Stack flexDirection="row">
      <HelperText>{message}</HelperText>
      <Divider />
      <HelperText>
        {counter}/{maxLength}
      </HelperText>
    </Stack>
  )
}
